import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DescriptorFormControl } from '../../descriptor/descriptor-form-control';
import { VedraxFile } from '../../util/vedrax-file';

@Component({
  selector: 'vedrax-input-file',
  templateUrl: './vedrax-input-file.component.html',
  styleUrls: ['./vedrax-input-file.component.scss']
})
export class VedraxInputFileComponent implements OnInit {

  @Input() form: FormGroup = new FormGroup({});
  @Input() descriptor: DescriptorFormControl = new DescriptorFormControl();

  removable = true;

  constructor() { }

  uploadFile: VedraxFile = new VedraxFile();

  ngOnInit(): void {
  }

  /**
   * Method for handling file
   * @param uploadedFile 
   */
  handleUploadedFile(uploadedFile: VedraxFile = new VedraxFile()) {

    this.uploadFile = uploadedFile;

    const control = this.form.get(this.descriptor.controlName);

    if (control) {
      control.setValue(uploadedFile.file);
    }


  }

}
